// Argent 钱包
// 部署在 Ropsten 测试网和主网上，简单的合约来检测给定地址是否对应于 Argent 钱包
import ARGENT_WALLET_DETECTOR_ABI from './argent-wallet-detector.json'
// 合约部署在ether主网上的地址
const ARGENT_WALLET_DETECTOR_MAINNET_ADDRESS = '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8'

export { ARGENT_WALLET_DETECTOR_ABI, ARGENT_WALLET_DETECTOR_MAINNET_ADDRESS }
